import {
  type ApiOpeazOpAdhSummary,
  api,
  useSuspenseQuery,
} from "@pharmupp/p3-front-commons"

export const useMyBriOperationsSummary = () => {
  const { data: operations } = useSuspenseQuery({
    queryKey: ["opeaz-operations", "adherent", "summary"],
    queryFn: () =>
      api.get<ApiOpeazOpAdhSummary>("/api/operation/opeaz/adherent/summary"),
  })
  return { operations }
}
